import { useEffect } from 'react';
import {
  BOTTOM_LAYER_ABOVE_SATELLITE,
  CONTOUR_LABELS_ID,
  CONTOUR_LAYERS,
  CONTOUR_LAYER_ID,
  CONTOUR_OUTLINE_ID,
} from '../../constants/map';
import { useUnitContext } from '../../contexts/UnitContext';

const unitsMap = {
  default: [
    'concat',
    ['to-string', ['get', 'ele']],
    'm (',
    ['to-string', ['*', ['get', 'ele'], 3.3]],
    'ft)',
  ],
  metric: ['concat', ['to-string', ['get', 'ele']], 'm'],
};

const ContourLayer = ({ map }) => {
  const { units } = useUnitContext();
  useEffect(() => {
    map.addSource('mapbox-contour', {
      type: 'vector',
      url: 'mapbox://mapbox.mapbox-terrain-v2',
      minZoom: 0,
    });

    map.addLayer(
      {
        id: CONTOUR_OUTLINE_ID,
        source: 'mapbox-contour',
        'source-layer': 'contour',
        paint: {
          'line-color': 'white',
          'line-gap-width': 0.25,
        },
        type: 'line',
        minZoom: 0,
        layout: {
          visibility: 'none',
        },
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    map.addLayer(
      {
        id: CONTOUR_LAYER_ID,
        source: 'mapbox-contour',
        'source-layer': 'contour',
        type: 'line',
        minZoom: 0,
        layout: {
          visibility: 'none',
        },
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    map.addLayer(
      {
        id: CONTOUR_LABELS_ID,
        source: 'mapbox-contour',
        'source-layer': 'contour',
        type: 'symbol',
        minZoom: 0,
        layout: {
          visibility: 'none',
          'symbol-placement': 'line',
          'text-field': unitsMap[units],
          'text-anchor': 'bottom',
          'text-size': 12,
        },
        paint: {
          'icon-color': 'white',
          'icon-halo-width': 1,
          'text-color': 'white',
          'text-halo-width': 1,
          'text-halo-color': 'black',
        },
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    return () => {
      // eslint-disable-next-line no-underscore-dangle
      if (map && !map._removed) {
        CONTOUR_LAYERS.forEach((layerId) => map.removeLayer(layerId));
        map.removeSource('mapbox-contour');
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    map.setLayoutProperty(CONTOUR_LABELS_ID, 'text-field', unitsMap[units]);
  }, [units]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default ContourLayer;
